import { post, get } from "../utility/fetch-util";

export const pushSubscribe = async (subscription, progress) => {
    console.log('pushSubscribe');
    console.log(subscription);    
    
    return post('/api/webpush/subscribe', null, subscription, progress);
}

export const pushUnsubscribe = async (endPoint, progress) => {
    const params = {};
    params["endPoint"] = endPoint;
    return post('/api/webpush/unsubscribe', params, null, progress);
}

export const getFirebaseConfiguration = async(progress) => {
    return get('/api/webpush/firebase', null, null, progress);
}

export const getSubscriptionStatus = async(endPoint, progress) => {
    const params = {};
    params["endPoint"] = endPoint;
    return get('/api/webpush/status', params, null, progress);
}
